module.exports = __webpack_public_path__ + "static/media/import_1.d3e7b26b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/import_1.jpg
// module id = 1852
// module chunks = 0